import { type ReactNode } from 'react'
import { Head } from '@inertiajs/react'
import AdminLayout from '@/components/AdminLayout'
import ResearchNav from '@/components/admin/research/ResearchNav'
import ResearchEventForm from '@/components/admin/research/ResearchEventForm'
import type {
  ResearchCustomFieldDef,
  ResearchSuggestions,
  ResearchVenueOption,
} from '@/types/research'

type Props = {
  organizations: { id: string; name: string }[]
  venues: ResearchVenueOption[]
  sponsor_names: string[]
  industries: string[]
  suggestions: ResearchSuggestions
  causes: string[]
  custom_fields: ResearchCustomFieldDef[]
  preselected_organization_id: string | null
}

export default function ResearchEventNew({
  organizations,
  venues,
  sponsor_names,
  industries,
  suggestions,
  causes,
  custom_fields,
  preselected_organization_id,
}: Props) {
  return (
    <>
      <Head title="Research - New Event" />
      <div>
        <h1 className="text-3xl font-semibold tracking-tight font-serif">Research Database</h1>
        <div className="mt-4">
          <ResearchNav />
        </div>
        <h2 className="mb-6 text-2xl font-semibold tracking-tight">New Research Entry</h2>
        <div className="max-w-4xl">
          <ResearchEventForm
            organizations={organizations}
            venues={venues}
            sponsorNames={sponsor_names}
            industries={industries}
            suggestions={suggestions}
            causes={causes}
            customFields={custom_fields}
            preselectedOrganizationId={preselected_organization_id}
          />
        </div>
      </div>
    </>
  )
}

ResearchEventNew.layout = (page: ReactNode) => <AdminLayout>{page}</AdminLayout>
